import complement from '@/storages/dexpara/Complement';
import examresult from '@/storages/dexpara/ExamResult';
import material from '@/storages/dexpara/Material';
import method from '@/storages/dexpara/Method';
import order from '@/storages/dexpara/Order';
import result from '@/storages/dexpara/Result';
import resultrange from '@/storages/dexpara/ResultRangeStorage';
import type from '@/storages/dexpara/Type';
import resultconversion from '@/storages/dexpara/ResultConversionStorage';

export default {
    name: 'dexpara',
    namespaced: true,
    state: {
        filters: [],
    },
    getters: {
        filters(state) {
            return state.filters
        },
    },
    mutations: {
        setFilters (state, array) {
            state.filters = array
        },
        resetFilters (state) {
            state.filters = []
        },
    },
    modules: {
        complement,
        examresult,
        material,
        method,
        order,
        result,
        type,
        resultrange,
        resultconversion
    }
}
